import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';
import { Box, Typography } from '@mui/material';
import {
  ActiveUserItem,
  ActiveUsersResponse,
  ActiveUserTableData,
  ActiveUserTableRowActions,
  UpdateUserRole
} from './interfaces';
import HelpInfoWrapper from '../../../../../common/help-info-wrapper';

export const mapApiDataIntoTableFormat = (
  data: ActiveUsersResponse,
  actionsHandling: ActiveUserTableRowActions
): ActiveUserTableData[] =>
  data.users.map((activeUserData: ActiveUserItem) => {
    const { userId, name, emailAddress, role, creationDate } = activeUserData;
    const actions = [
      {
        name: TABLE_ACTION.EDIT,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actionsHandling.openDetails(activeUserData, data.settings.availableRoles);
        }
      }
    ];
    return {
      id: userId,
      name,
      role: (
        <Box display="flex" justifyContent="space-between">
          <HelpInfoWrapper tooltip={role.description} tooltipPlacement="bottom">
            <Typography>{role.name}</Typography>
          </HelpInfoWrapper>
        </Box>
      ),
      emailAddress,
      creationDate,
      actions: <ActionsColumn actions={actions} />
    };
  });

export const mapToApiFormat = (userData: UpdateUserRole) => ({
  userId: userData.userId,
  roleId: userData.roleId
});
